import signoutFromMsal from './signoutFromMsal';
import { isFeatureEnabled } from 'owa-feature-flags';
import { signoutCleanup } from './signoutCleanup';
import { logStartUsage } from 'owa-analytics-start';
import type { MailboxInfo } from 'owa-client-types';

export default async function onActivityTimeoutErrorForMSAL(
    mailboxInfo?: MailboxInfo
): Promise<void> {
    // Call signoutCleanup if the feature is enabled
    if (isFeatureEnabled('auth-signout-cleanup')) {
        try {
            await signoutCleanup();
        } catch (error) {
            // Log only the error type, not the message, to avoid exposing sensitive information
            if (mailboxInfo) {
                logStartUsage('ActivityTimeoutMsalSignoutError', mailboxInfo, {
                    errorType: error instanceof Error ? error.name : 'Unknown',
                });
            }
        }
    }

    await signoutAndRedirect();
}
const signoutUrl = '/owa/logoff.owa';

async function signoutAndRedirect(): Promise<void> {
    await signoutFromMsal();

    // fallback to old logoff page since we do a local logout
    // with MSAL currently and dont redirect users.
    location.assign(signoutUrl);

    return Promise.resolve();
}
